module.exports = __webpack_public_path__ + "img/welcome-1-uae.e0311abc.png";